module.exports = __webpack_public_path__ + "assets/icons/ic_photo_library-868e.svg";